import EditAdminsScreen from "../modules/users/EditAdminScreen"

export default function EditAdmin() {
  return (
    <>
      <EditAdminsScreen />
    </>
  )
}
